"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useCampaignDialogs } from "../Providers/CampaignDialogsContext";
import { useCloneDialog } from "../Providers/CloneDialogContext";
import { cloneCampaignsAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { setRowSelectionModel } = useCampaignDialogs();
  const { campaignIdsToClone, closeCloneDialog } = useCloneDialog();

  const handleAction = async (formData: FormData) => {
    const result = await cloneCampaignsAction(formData);
    if (result.success) {
      closeCloneDialog();
      setRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
    } else {
      console.error("Error cloning campaigns:", result.error);
    }
  };

  return (
    <NextForm action={handleAction}>
      {campaignIdsToClone.map((id) => (
        <input key={id} type="hidden" name="ids" value={id} />
      ))}
      {children}
    </NextForm>
  );
}
